import Commons from '../../../Services/Common/Common';

/**
 * 회의록 목록 (M_MET_BASIC) 요청 파라미터 매핑
 * 사용처: M_MET_BASIC_Query.js (useSearch1, useSearch2, useSearch3)
 */
export const MET_BASIC_Schema = {
  mapper: {
    /** useSearch2 → GetMetBasicR2 (안전보건 협의체 회의록) SP_SUB_BASIC_03_R2 */
    search2: {
      ProceedingsYear: (context) =>
        Commons.EncryptAES(
          (context.search?.year ?? new Date().getFullYear().toString())
        ) || '',
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
      UserId: (context) => context.userInfo?.userid ?? '',
    },
    /** useSearch3 → GetMetBasicR3 (산업안전보건위원회 회의록) SP_SAC_BASIC_R6 */
    search3: {
      ProceedingsYear: (context) =>
        Commons.EncryptAES(
          (context.search?.year ?? new Date().getFullYear().toString())
        ) || '',
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
      UserId: (context) => context.userInfo?.userid ?? '',
    },
  },
};
